export default __webpack_public_path__ + "static/media/new_dashboard_quick_link_icon.7838f4ae.svg";